<template>
    <div class="crb">
        <div class="crb__overview" aria-live="polite">
            <span v-for="stat in summary" :key="stat.key" class="crb__stat" :title="stat.hint">
                <span class="crb__dot badge" :class="'badge-credit-request-status-' + stat.color" aria-hidden="true"></span><b>{{stat.count}}</b><span>{{stat.label}}</span>
            </span>
        </div>
        <div class="crb__toolbar">
            <div><strong>Банки</strong><span class="crb__count">{{banks_count}} · заявок {{credit_requests_count}}</span></div>
            <div class="crb__links">
                <button type="button" v-if="credit_requests_by_hash" class="crb__link" @click="visibleModalCreditRequestsByHash = true">Кред. заявки других салонов</button>
                <button type="button" v-if="$hasPermission('banks.agreements.generate')" class="crb__link" :disabled="agreements_loading" @click="downloadAgreements()">
                    {{agreements_loading ? 'Готовим соглашения…' : 'Скачать все соглашения'}} <span aria-hidden="true">↓</span>
                </button>
            </div>
        </div>
        <div ref="scroll" class="crb__scroll">
            <table class="crb__table">
                <caption class="sr-only">Банки по заявке №{{request.id}}. Ответственный, статус и решение банка редактируются независимо.</caption>
                <colgroup><col style="width: 22%"><col style="width: 23%"><col style="width: 28%"><col><col style="width: 44px"></colgroup>
                <thead>
                <tr><th scope="col">Банк</th><th scope="col">Ответственный</th><th scope="col">Статус</th><th scope="col">Решение банка</th><th scope="col"><span class="sr-only">Действия</span></th></tr>
                </thead>
                <CreditRequestItem v-for="item in banks_groups.car" :bank="item.bank" :key="item.bank.id" :credit_request_model="item.credit_request" :managers_select="managers_select" :request_id="request.id" :request="request" :credit_type="item.type" :origin="item.bank.slug === origin" />
                <tbody v-if="banks_groups.consumer.length"><tr class="crb__group-row"><td colspan="5">Потребительский кредит</td></tr></tbody>
                <CreditRequestItem v-for="item in banks_groups.consumer" :bank="item.bank" :key="'consumer' + item.bank.id" :credit_request_model="item.credit_request" :managers_select="managers_select" :request_id="request.id" :request="request" :credit_type="item.type" :origin="item.bank.slug === origin" />
            </table>
        </div>

        <el-dialog v-if="credit_requests_by_hash" title="Кред. заявки других салонов" :visible.sync="visibleModalCreditRequestsByHash" width="600px" :append-to-body="true">
            <el-tabs type="card">
                <template v-for="(p_list, p_id) in credit_requests_by_hash">
                    <el-tab-pane :label="PlatformHelper.get(p_id).name">
                        <template v-for="r_list in p_list">
                            <table class="table table-sm">
                                <thead>
                                <tr>
                                    <th>Банк</th>
                                    <th>Статус</th>
                                    <th>Решение банка</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="r in r_list">
                                    <tr>
                                        <td>{{r.bank_name}}</td>
                                        <td>{{r.status_label}}</td>
                                        <td>{{r.bank_decision_label}}</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </template>
                    </el-tab-pane>
                </template>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    import CreditRequestItem from "./CreditRequestItem";
    import PlatformHelper from "../../../helpers/platform";
    import CreditRequestStatusData from "../../../plugins/credit_request_status_data";
    export default {
        name: "CreditRequestsBlock",
        components: {CreditRequestItem},
        // origin — slug банка, по ячейке которого открыли окно: строку подсвечиваем и прокручиваем к ней
        props: ['request', 'managers_select', 'origin'],
        data: () => ({
            agreements_loading: false,
            credit_requests_by_hash: null,
            visibleModalCreditRequestsByHash: false,
        }),
        mounted() {
            let self = this;
            this.fetchCreditRequestsByHash();
            this.$nextTick(() => {
                let row = this.origin && this.$el.querySelector('.crb-row[data-bank="' + this.origin + '"]');
                if (row) row.scrollIntoView({block: 'center'});
            });
            Echo.private(`request.${this.request.id}.credit_requests`)
                .listen('.credit_request.created', function (e) {
                    self.$store.dispatch('credit_requests/update', {
                        bank_id: e.credit_request.bank_id,
                        credit_type: e.credit_request.credit_type,
                        request: e.credit_request,
                    });
                    self.$bus.$emit('credit-request:created-websocket', {
                        request_id: e.credit_request.request_id,
                        bank_id: e.credit_request.bank_id,
                        credit_type: e.credit_request.credit_type,
                        credit_request: e.credit_request,
                    });
                })
                .listen('.credit_request.updated', function (e) {
                    self.$store.dispatch('credit_requests/update', {
                        bank_id: e.credit_request.bank_id,
                        credit_type: e.credit_request.credit_type,
                        request: e.credit_request,
                    });
                    self.$bus.$emit('credit-request:updated-websocket', {
                        request_id: e.credit_request.request_id,
                        bank_id: e.credit_request.bank_id,
                        credit_type: e.credit_request.credit_type,
                        credit_request: e.credit_request,
                    });
                })
                .listen('.credit_request.deleted', function (e) {
                    self.$store.dispatch('credit_requests/remove', {
                        bank_id: e.bank.id,
                        credit_type: e.credit_type,
                    });
                    self.$bus.$emit('credit-request:deleted-websocket', {
                        request_id: e.request.id,
                        bank_id: e.bank.id,
                        credit_type: e.credit_type,
                    });
                });
        },
        computed: {
            PlatformHelper() {
                return PlatformHelper
            },
            banks_groups() {
                let self = this;
                let data = {
                    car: [],
                    consumer: [],
                };
                let platform = _.find(this.$store.getters['platforms/all'], ['id', this.request.platform_id]);
                let allow_banks = platform && platform.allow_banks ? platform.allow_banks : [];
                this.$store.getters['banks/all'].forEach(function (bank) {
                    if (!allow_banks.includes(bank.id)) return;
                    if (bank.slug === 'pochta' || bank.slug === 'plus' || bank.slug === 'baltinvest' || bank.slug === 'soyuz') return;
                    let item = {
                        bank: null,
                        type: null,
                        credit_request: null,
                    };
                    item.bank = bank;
                    item.type = (bank.slug !== 'pochta') ? 'car' : 'consumer';
                    let find_credit_request = _.find(self.request.credit_requests, {bank_id: item.bank.id, credit_type: item.type});
                    item.credit_request = find_credit_request ? find_credit_request : null;

                    (item.type === 'car') ? data.car.push(item) : data.consumer.push(item);
                });
                return data;
            },
            // Заявки банков, показанных в окне; store обновляют строки и websocket
            visible_credit_requests() {
                let current = this.$store.getters['credit_requests/current_requests'];
                return this.banks_groups.car.concat(this.banks_groups.consumer)
                    .map(item => current[item.bank.id + "_" + item.type])
                    .filter(r => r && r.id);
            },
            banks_count() {
                return this.banks_groups.car.length + this.banks_groups.consumer.length;
            },
            credit_requests_count() {
                return this.visible_credit_requests.length;
            },
            summary() {
                let statuses = CreditRequestStatusData.data();
                return CreditRequestStatusData.summaryGroups().map(group => ({
                    key: group.key,
                    label: group.label,
                    color: group.color,
                    hint: group.statuses.map(slug => statuses[slug].label).join(' · '),
                    count: this.visible_credit_requests.filter(r => group.statuses.includes(r.status)).length,
                }));
            },
        },
        beforeDestroy() {
            this.$store.dispatch('credit_requests/clear');
            Echo.leave(`request.${this.request.id}.credit_requests`);
        },
        methods: {
            downloadAgreements() {
                let self = this;
                if (!this.request.profiles || !this.request.profiles.length) {
                    this.$message.error({
                        message: 'Создайте анкету',
                        duration: 2000,
                    });
                } else {
                    this.agreements_loading = true;
                    axios.get('/api/banks/agreements/generate/' + this.request.id + '/all', {responseType: 'arraybuffer'})
                        .then(function (response) {
                            self.agreements_loading = false;
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(new Blob([response.data]));
                            link.setAttribute('download', 'agreements_' + self.request.id + "_" + (new Date).getTime() + '.zip');
                            document.body.appendChild(link);
                            link.click()
                        })
                        .catch(function (e) {
                            self.agreements_loading = false;
                            self.$message.error({
                                message: 'Не удалось сгенерировать соглашения',
                                duration: 2000,
                            });
                        })
                }
            },
            fetchCreditRequestsByHash() {
                let self = this;
                axios.get('/api/requests/' + this.request.id + '/credit_requests', {params: {byHash: 1}})
                    .then(response => {
                        self.credit_requests_by_hash = response.data
                    });
            },
        }
    }
</script>

<style scoped>
    .crb {
        display: flex;
        flex-direction: column;
        min-height: 0;
        color: #3F4B57;
        /* el-dialog__body задаёт break-all и рвёт названия банков посредине слова */
        word-break: normal;
    }
    .crb__overview {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 9px 17px;
        padding: 0 var(--crb-gutter, 12px) 18px;
        font-size: 12px;
    }
    .crb__stat {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;
    }
    .crb__stat b {
        font-weight: 600;
        font-variant-numeric: tabular-nums;
    }
    .crb__stat span:last-child {
        color: #6c757d;
    }
    .crb__dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        padding: 0;
        border-radius: 50%;
    }
    .crb__toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 8px 12px;
        padding: 12px var(--crb-gutter, 12px);
        border-top: 1px solid #e9ecef;
    }
    .crb__toolbar > div {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .crb__toolbar strong {
        font-weight: 600;
    }
    .crb__count {
        color: #6c757d;
        font-size: 12px;
        font-variant-numeric: tabular-nums;
    }
    .crb__links {
        gap: 18px !important;
    }
    .crb__link {
        padding: 4px 0;
        border: 0;
        background: transparent;
        color: #2c7be5;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
    }
    .crb__link:hover:not(:disabled) {
        text-decoration: underline;
        color: #1657af;
    }
    .crb__link:disabled {
        opacity: .6;
        cursor: default;
    }
    .crb__link span {
        margin-left: 4px;
        font-size: 15px;
    }
    .crb__scroll {
        min-height: 80px;
        //overflow: auto;
        //overscroll-behavior: contain;
    }
    .crb__table {
        width: 100%;
        min-width: 700px;
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
    }
    .crb__table th {
        position: sticky;
        top: 0;
        z-index: 2;
        height: 34px;
        padding: 0 12px;
        border-top: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
        background: #f7f9fb;
        color: #6c757d;
        font-size: 11px;
        font-weight: 600;
        text-align: left;
    }
    .crb__table th:first-child {
        padding-left: var(--crb-gutter, 12px);
    }
    .crb__table th:last-child {
        padding: 0 12px 0 0;
    }
    .crb__group-row td {
        padding: 14px var(--crb-gutter, 12px) 6px;
        border-bottom: 1px solid #e9ecef;
        color: #6c757d;
        font-size: 11px;
        font-weight: 600;
    }
</style>
